import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import "./ChooseAc.css";

const ChooseAccount = () => {
  const { setUserType } = useContext(AuthContext);
  const navigate = useNavigate();
 

  const handleUserTypeSelect = (userType) => {
    setUserType(userType);
    navigate("/Signup");
  };

  return (
    <div className="choose-account-container">
      <div className="contents">
        <div className="wrap">
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <Link to="/" >Back</Link>
        </div>
        <div className="card">
          <h3 >Create account</h3>
          <p >Choose account type</p>
          <div className="charter" onClick={() => handleUserTypeSelect("Charterer")} >
            <h3>For Charterer</h3>
            <p>Find and rent shipping vessels</p>
          </div>
         <div className="vessel-owner" onClick={() => handleUserTypeSelect("Vessel Owner")}>
          <h3>For Vessel Owner</h3>
          <p>Upload and manage your vessel for charter</p>
         </div>
         {/* <span>Already have an account? <Link to='/Login'>Sign in</Link></span> */}
        </div>
      </div>
      <div className="img"></div>
    </div>
  );
};

export default ChooseAccount;
